import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { StyleSheet, css } from 'aphrodite';
import { mapStateToProps, mapDispatchToProps } from '../../utils';

import { getResources } from '../../actions/applicationData';
import { updateAppState } from '../../actions/applicationState';

import ContentContainer from '../../components/ContentContainer';
import ResourceCard from '../../components/ResourceCard';
import { Theme } from '../../config/theme';

class SettingsResources extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resources: [],
      loaded: false,
    };
  }

  componentWillMount() {
    this.fetchFAQs();
  }

  fetchFAQs() {
    this.props.dispatch(updateAppState({
      loading: true,
    })).then(() => {
      this.props.dispatch(
        getResources(),
      ).then((response) => {
        this.setState({
          resources: response,
          loaded: true,
        });

        this.props.dispatch(updateAppState({
          loading: false,
        }));
      }, (err) => {
        console.log(err); // eslint-disable-line no-console
        this.props.dispatch(updateAppState({
          loading: false,
        }));
        this.props.history.push('/404');
      });
    });
  }

  render() {
    return (
      <ContentContainer>
        <div className={css(styles.container)}>
          {
            this.state.loaded && this.state.resources.length ?
            this.state.resources.filter(resource =>
              resource.type === this.props.user.subscription,
            ).filter(resource => (
              resource.url && resource.url.length &&
              resource.title && resource.title.length &&
              resource.summary && resource.summary.length
            )).map(resource => (
              <ResourceCard
                link={resource.url}
                title={resource.title}
                summary={resource.summary} />
            )) : false
          }
        </div>
      </ContentContainer>
    );
  }
}

SettingsResources.propTypes = {
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};


const styles = StyleSheet.create({
  heading: {
    marginBottom: 30,
    lineHeight: 2.09,
    textAlign: 'center',
    fontSize: 28,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
  },
  cards: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingsResources);



// WEBPACK FOOTER //
// ./src/views/SettingsResources/index.js